import { defineRecipe } from '@plurall/elo-v3';

export const aiInsightCardRecipe = defineRecipe({
  className: 'ai-insight-card',
  base: {
    borderWidth: 'border.width.medium!',
    fontFamily: 'body',
    fontWeight: 'font.weight.regular',
    fontSize: 'font.size.small',
    verticalAlign: 'middle',
    paddingBlock: 'space.12',
    paddingInline: 'space.16',
    marginTop: 'space.48',
  },
  variants: {
    status: {
      success: {
        background: 'background.feedback.success.primary.alpha!',
        borderColor: 'border.feedback.success.secondary!',
        color: 'text.feedback.success',
      },
      warning: {
        background: 'background.feedback.warning.primary.alpha!',
        borderColor: 'border.feedback.warning.secondary!',
        color: 'text.feedback.warning',
      },
    },
  },
});
